document.addEventListener('DOMContentLoaded', function() {
  const productFormWrapper = document.querySelector('[data-product-form-wrapper]');
  const triggerElement = productFormWrapper ? productFormWrapper.querySelector('.add__buttons__buy') : null;
  const originalBuyButton = triggerElement ? triggerElement.querySelector('button[name="add"]') : null;

  const stickyBar = document.getElementById('sticky-add-to-cart');
  const stickyButton = document.getElementById('sticky-add-to-cart-button');
  const stickyPricingContainer = stickyBar ? stickyBar.querySelector('.sticky-add-to-cart__pricing') : null;

  const floatingElementSelectors = ['.whatsapp-link', '#shopify-chat'];

  if (!triggerElement || !stickyBar || !originalBuyButton || !stickyPricingContainer) {
    if (stickyBar) stickyBar.style.display = 'none';
    return;
  }

  const updateStickyPricing = () => {
    const originalPriceWrapper = productFormWrapper.querySelector('.product__block__price_with-whatsapp');
    if (originalPriceWrapper) {
      stickyPricingContainer.innerHTML = originalPriceWrapper.innerHTML;
      const whatsAppButton = stickyPricingContainer.querySelector('.whatsapp-prod-button');
      if (whatsAppButton) {
        whatsAppButton.remove();
      }
    }
  };

  const toggleFloatingElements = (isStickyVisible) => {
    floatingElementSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(element => {
        element.classList.toggle('stick_prod_open', isStickyVisible);
      });
    });
  };

  let isTriggerOutOfView = false;

  const handleVisibility = () => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const shouldBeVisible = isTriggerOutOfView && isMobile;

    stickyBar.classList.toggle('is-visible', shouldBeVisible);
    toggleFloatingElements(shouldBeVisible);
  };

  const intersectionObserver = new IntersectionObserver(
    ([entry]) => {
      isTriggerOutOfView = !entry.isIntersecting;
      handleVisibility();
    },
    { threshold: 0 }
  );

  const domObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches('#shopify-chat')) {
            const isStickyVisible = stickyBar.classList.contains('is-visible');
            node.classList.toggle('stick_prod_open', isStickyVisible);
          }
        });
      }
    }
  });

  intersectionObserver.observe(triggerElement);
  domObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', handleVisibility);

  stickyButton.addEventListener('click', () => {
    originalBuyButton.click();
  });

  const buttonObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const isLoading = originalBuyButton.classList.contains('loading');
        const isSuccess = originalBuyButton.classList.contains('has-success');
        stickyButton.classList.toggle('loading', isLoading);
        stickyButton.classList.toggle('has-success', isSuccess);
      }
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        if (originalBuyButton.hasAttribute('disabled')) {
          stickyButton.setAttribute('disabled', 'disabled');
        } else {
          stickyButton.removeAttribute('disabled');
        }
      }
    }
  });

  buttonObserver.observe(originalBuyButton, { attributes: true });

  updateStickyPricing();

  if (productFormWrapper) {
    productFormWrapper.addEventListener('variant:change', updateStickyPricing);
  }
});
